import { AutoSuggestSymbol, MarketType, SymbolType } from '@tdwb/core';

export enum SearchResultType {
  HELP = 'help',
  EDUCATION = 'education',
  SYMBOL = 'symbol'
}

export interface SearchResult {
  categoryOrder: Array<SearchResultType>;
  help: Array<SearchResultItem>;
  education: Array<SearchResultItem>;
  symbol: Array<AutoSuggestSymbol>;
}

export interface SearchResultItem {
  itemType: SearchResultType;
  url: string;
  title: string;
  content: Array<string>;
  thumbnailUrl?: string;
}

export interface RecentSearchItem {
  priority?: number;
  searchText: string;
  market?: MarketType;
  description?: string;
  symbolType?: SymbolType;
}
